export default "__VITE_ASSET__NiRe_AcF__";